import React from "react";
import styled, { css } from "styled-components";

export default styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;
